import { render, staticRenderFns } from "./CustomExtensionPreviewModal.vue?vue&type=template&id=8b867944&scoped=true&"
import script from "./CustomExtensionPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./CustomExtensionPreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomExtensionPreviewModal.vue?vue&type=style&index=0&id=8b867944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b867944",
  null
  
)

export default component.exports